// 获取 Strapi API URL
const getApiUrl = () => {
  // 1. 优先使用自定义环境变量（可在 .env 文件或部署时注入）
  if (process.env.REACT_APP_API_URL) {
    // 确保环境变量中的URL不包含端口号
    const apiUrl = process.env.REACT_APP_API_URL;
    return apiUrl;
  }
  
  // 2. 根据访问环境确定后端地址
  const host = window.location.hostname;
  const protocol = window.location.protocol;
  
  // 如果是本地开发环境
  if (host === 'localhost' || host === '127.0.0.1') {
    const port = process.env.STRAPI_PORT || 1337;
    const devUrl = `${protocol}//localhost:${port}`;
    return devUrl;
  }
  
  // 生产环境：使用当前域名，不包含端口号
  const prodUrl = `${protocol}//${host}`;
  return prodUrl;
};

export const API_URL = getApiUrl();

// 添加调试信息

// 生产环境默认访客token
export const GUEST_TOKEN = '10b5c0a24756f497a36d671addca619976f47155ea72e8709a06876103dbf29c3b88688ab061ea1aa46445c29e2afee226d609e4b0ec11ac05f1c6488b66c7a8f3306932df58538863bb2f79772ccdba2b467712d50bb2d8228f0180ab0f908dca44a7f8a372474ae5fccc7550feaa540b057b394ef63f76268692ddbf6d72bc';
// 开发环境默认访客token
//export const GUEST_TOKEN = 'aec8e1a879fb1570689bc7db2011b978f8008624086c76fca24dd2ab0abff72a88f6b8e9edcc778d2fa1169222977106964e21c9132333ff3d442003a9cd0bc1a123da6e8e91e3a66e568557130fa7c487ae70d0a0bbdad2cfc0fa9fd481e13de0582c61c43132f94157ef40961d910b67cd9d280a91ad1a2c92f59d2f768a12';

// 添加一个验证函数
export const validateApiUrl = () => {
  if (API_URL.includes(':1337') && !API_URL.includes('localhost')) {
    console.error('警告: 生产环境中检测到端口1337，这可能导致连接问题');
    console.error('当前API_URL:', API_URL);
    console.error('请检查REACT_APP_API_URL环境变量设置');
  }
};

// 在开发环境中运行验证
if (process.env.NODE_ENV === 'development') {
  validateApiUrl();
}